import {PublicRoute} from "./enum";
import {flattenRouteInfo} from "../helpers/flattenRouteInfo";

/**
 * ROUTE
 * - id: PublicRoute
 * - path: string
 * - children: ROUTE[] [optional]
 *
 * Route Blocking due to Permission or Subscription
 * - permission: PermissionKey
 * - subscription: SubscriptionScopeKey
 * - create: boolean
 * - update: boolean
 * - view: boolean
 * - inhibitorModifiers: Array of M3
 *
 * Wrapper Provider
 * - wrapper: Provider
 * - wrapperProps: props-like object {}
 *
 * Miscellaneous
 * - sidebarParentId: PublicRoute
 */

const PublicRouteInfo = [
    {
        id: PublicRoute.Page404,
        path: '404',
    },
    {
        id: PublicRoute.Page500,
        path: '500',
    },
    {
        id: PublicRoute.SignIn,
        path: 'signin',
    },
    {
        id: PublicRoute.Invite,
        path: 'invite/:id/:secret',
    },
    {
        id: PublicRoute.SignUp,
        path: 'signup/:code?',
    },
    {
        id: PublicRoute.Activate,
        path: 'activate',
    },
    {
        id: PublicRoute.ForgotPassword,
        path: 'forgot-password',
    },
    {
        id: PublicRoute.TransactionView,
        path: 'view/:id/:ct',
    },
    {
        id: PublicRoute.TransactionViewV2,
        path: 'v/:id/:transactionEmailId?',
    },
    {
        id: PublicRoute.TransactionViewV3,
        path: 't/:hash/:transactionEmailId?',
    },
    {
        id: PublicRoute.TransactionViewV3ShortLink,
        path: 'l/:hash/:transactionEmailId?',
    },
    {
        id: PublicRoute.TransactionViewV3ShortLink,
        path: 'l/:hash/:transactionEmailId?/:fileName?',
    },
    {
        id: PublicRoute.MiniPosOrderView,
        path: 'o/:hash/e-invoice',
    },
    {
        id: PublicRoute.StatementView,
        path: 'view-statement/:id/:ct',
    },
    {
        id: PublicRoute.StatementViewV2,
        path: 's/:statementId/:hash/:emailId?',
    },
    {
        id: PublicRoute.StatementViewV2,
        path: 's/:statementId/:hash/:emailId?/:fileName?',
    },
    {
        id: PublicRoute.NoPreview,
        path: 'no-preview',
    },
    {
        id: PublicRoute.NoPreviewIframe,
        path: 'no-preview-iframe',
    },
    {
        id: PublicRoute.ContactMyinvoisData,
        path: 'm/:hash',
    },
    {
        id: PublicRoute.PriceAdjustment,
        path: 'price_transition/:companyId/:hash',
    },
];

export default flattenRouteInfo(PublicRouteInfo);
